(function () {
    'use strict';

    angular
        .module('SelectPersonControllers', [])
        .controller('SelectPersonController', Controller);

    Controller.$inject = ['$scope', 'esbEmployeeService', 'pagerService', '$timeout'];

    function Controller($scope, searchService, pagerService, $timeout) {
        $scope.ctxSelectPerson = {};

        $scope.availablePersons = [];
        $scope.searchPersons = searchPersons;
        $scope.pager = pagerService.newPager({ numberOfItemsPerPage: 11 });

        $scope.pager.updatePagerFromItems($scope.availablePersons);

        function searchPersons() {
            var searchTerm = $scope.ctxSelectPerson.searchTerm;
            if (_.isUndefined(searchTerm) || searchTerm.length < 3) {
                $scope.availablePersons = [];
                $scope.pager.updatePagerFromItems($scope.availablePersons);
                return;
            }
            var searchEmployeeFunc = searchService.searchEmployees;

            if ($scope.isToSendEmail) searchEmployeeFunc = searchService.searchEmployeesForSendEmail;

            searchEmployeeFunc(searchTerm)
                .then(function (foundPersons) {
                    $scope.availablePersons = _.filter(foundPersons, function (person) {
                        return !person.DepartureDate;
                    });
                    $scope.pager.updatePagerFromItems($scope.availablePersons);
                });
        }
    }
})();